import axios from 'axios';
import Cookies from 'js-cookie';
import { USER_TYPE_OPTIONS } from 'utils/jwt';

const USER_TOKEN_KEY = 'user_token';
const USER_TYPE_ENDPOINT = 'https://unbot.io/api/v1.0/auth/user_type';

const buildErrorMessage = (error) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  'Impossible de mettre à jour le type utilisateur.';

export const updateUserType = async (userType) => {
  if (!USER_TYPE_OPTIONS.includes(userType)) {
    throw new Error('Type utilisateur invalide');
  }

  const jwt = Cookies.get(USER_TOKEN_KEY);
  if (!jwt) {
    throw new Error('Session expirée. Merci de vous reconnecter.');
  }

  try {
    const response = await axios.patch(
      USER_TYPE_ENDPOINT,
      { userType },
      {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      }
    );

    const nextJwt = response?.data?.jwt;
    if (!nextJwt) {
      throw new Error('Réponse invalide du serveur (JWT manquant).');
    }

    Cookies.set(USER_TOKEN_KEY, nextJwt, { expires: 365 });
    return response.data;
  } catch (error) {
    throw new Error(buildErrorMessage(error));
  }
};
